import React, { Component, Fragment } from "react";
import { Modal, Form, Col, Button } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import { toast } from 'react-toastify';
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Loading,
  SelectEstados,
  SelectTipoColegio,
  TypeaheadMunicipios
} from "../../../components";
import { validEmailRegex } from "../../../utils/validation";
import { formatFone } from "../../../utils/fone";
import api from "../../../services/api";

const resetErrors = { idEstado: '', municipio: '', colegio: '', email: '' };

class FormColegio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isLoading: false,
      alert: null,
      record: {},
      errors: resetErrors
    };
    this.loadFromAPI = props.loadFromAPI;
    this.closeModalForm = props.closeModalForm;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.showModal !== state.showModal) {
      let record = JSON.parse(JSON.stringify(props.record));
      for (const key in record) {
        if (record[key] === null) record[key] = '';
      }

      return {
        showModal: props.showModal,
        record: record
      };
    }
    return null;
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      isLoading: false,
      record: this.props.emptyRecord,
      errors: resetErrors
    }, () => this.closeModalForm());
  };

  validateInput = (name, value, errors) => {
    switch (name) {
      case 'idEstado':
        errors.idEstado = !value ? 'Selecione um ESTADO' : '';
        break;
      case 'municipio':
        errors.municipio = !value ? 'Preencha o campo MUNICÍPIO' : '';
        break;
      case 'colegio':
        errors.colegio = !value ? 'Preencha o campo COLÉGIO/ESCOLA' : '';
        break;
      case 'email':
        errors.email = (value && !validEmailRegex.test(value)) ? 'EMAIL inválido!' : '';
        break;
      default:
        break;
    }
    return errors;
  };

  validateForm = () => {
    let record = Object.assign({}, this.state.record),
      errors = Object.assign({}, this.state.errors);

    for (const key in record) {
      errors = this.validateInput(key, record[key], errors);
    }

    return errors;
  };

  handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.handleComponentChange(name, value);
  };

  handleComponentChange = (name, value) => {
    let record = Object.assign({}, this.state.record),
      errors = Object.assign({}, this.state.errors);

    if (name === 'fone') value = formatFone(value);

    record[name] = value;
    this.setState({
      record: record,
      errors: this.validateInput(name, value, errors)
    });
  };

  hideAlert = () => {
    this.setState({ alert: null });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const errors = this.validateForm();
    if (JSON.stringify(errors) !== JSON.stringify(resetErrors)) {
      this.setState({
        alert: (<SweetAlert warning title="Oops!" onConfirm={() => this.hideAlert()} showConfirm={false} timeout={2000}>Preenchimento incorreto!</SweetAlert>),
        errors: errors
      });
    } else {
      this.setState({ isLoading: true }, () => {
        api.post('/colegios', this.state.record)
          .then((response) => {
            if (response.data.message === 'ok') {
              toast.success('Colégio salvo com sucesso!');
              this.loadFromAPI();
              this.closeModal();
            } else {
              this.setState({
                isLoading: false,
                alert: (<SweetAlert warning title="Oops!" onConfirm={() => this.hideAlert()} showConfirm={false} timeout={2000}>{response.data.message}</SweetAlert>),
              });
            }
          })
          .catch((error) => {
            this.setState({ isLoading: false });
            toast.error('Falha ao enviar os dados!');
          });
      });
    }
  };

  render() {
    const { showModal, isLoading, alert, record, errors } = this.state;

    return (
      <Fragment>
        {alert}
        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>{record.id ? 'Editar' : 'Adicionar'} colégio/escola</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="loading">
              <Form id="form-colegio" className="form-horizontal form-sm form-custom" onSubmit={this.handleSubmit} noValidate>
                <CSSTransition
                  in={isLoading}
                  timeout={500}
                  classNames="fade"
                  unmountOnExit
                >
                  <div><Loading /></div>
                </CSSTransition>
                <Form.Row>
                  <Form.Group as={Col} xs={12} sm={8}>
                    <Form.Label>Colégio/Escola</Form.Label>
                    <Form.Control type="text"
                      name="colegio"
                      value={record.colegio}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      className={errors.colegio.length && 'is-invalid'}
                      required
                      noValidate
                    />
                    <Form.Control.Feedback type="invalid">{errors.colegio}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs={12} sm={4}>
                    <Form.Label>Tipo</Form.Label>
                    <SelectTipoColegio
                      name="tipo"
                      tipo={record.tipo}
                      onChange={this.handleComponentChange}
                    />
                    <Form.Control.Feedback type="invalid">{errors.tipo}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs={3}>
                    <Form.Label>Estado</Form.Label>
                    <SelectEstados
                      name="idEstado"
                      idEstado={record.idEstado}
                      onChange={this.handleComponentChange}
                      required
                      showUF
                      error={errors.idEstado}
                    />
                    <Form.Control.Feedback type="invalid">{errors.idEstado}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs={9}>
                    <Form.Label>Municipio</Form.Label>
                    
                    <TypeaheadMunicipios
                      name="municipio"
                      checkEstado
                      idEstado={record.idEstado}
                      municipio={record.municipio}
                      onChange={this.handleComponentChange}
                      required
                      error={errors.municipio}
                    />

                    <Form.Control.Feedback type="invalid">{errors.municipio}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs={12} sm={8}>
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email"
                      name="email"
                      value={record.email}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      className={errors.email.length && 'is-invalid'}
                      noValidate
                    />
                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} xs={12} sm={4}>
                    <Form.Label>Fone</Form.Label>
                    <Form.Control type="text"
                      name="fone"
                      value={record.fone}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      noValidate
                    />
                  </Form.Group>
                </Form.Row>
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={this.closeModal}>Cancelar</Button>
            <Button variant="success" form="form-colegio" type="submit">Salvar</Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

export default FormColegio;